import { render } from "./SignUpRegistration.vue?vue&type=template&id=48e0c774"
import script from "./SignUpRegistration.vue?vue&type=script&lang=js"
export * from "./SignUpRegistration.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Episcenter\\smartCity\\smartcity\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__